import { z } from 'zod';
import { AiAdvanceValidationError } from '../../ai-platform/ports.js';
import { availabilitySlotSchema, availabilityStaffSchema } from '../../ai-platform/availability-platform.js';

export const CDLIT_AVAILABILITY_FORBIDDEN_BODY_FIELDS = [
  'serviceId',
  'serviceExternalId',
  'companyId',
  'bookingCompanyId',
  'locationId',
  'tenantKey',
  'productKey',
  'staffId',
  'date',
  'slotDate',
  'slotTime',
] as const;

export const cdlitAvailabilityStaffListResponseSchema = z
  .object({
    staff: z.array(availabilityStaffSchema),
  })
  .strict();

export type CdlitAvailabilityStaffListResponse = z.infer<typeof cdlitAvailabilityStaffListResponseSchema>;

export const cdlitAvailabilitySlotsListResponseSchema = z
  .object({
    slots: z.array(availabilitySlotSchema),
  })
  .strict();

export type CdlitAvailabilitySlotsListResponse = z.infer<typeof cdlitAvailabilitySlotsListResponseSchema>;

export const cdlitAvailabilityDatesListResponseSchema = z
  .object({
    dates: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).max(14),
  })
  .strict();

export type CdlitAvailabilityDatesListResponse = z.infer<typeof cdlitAvailabilityDatesListResponseSchema>;

export const cdlitAvailabilitySelectStaffRequestSchema = z
  .object({
    staffExternalId: z.string().regex(/^\d{1,32}$/),
  })
  .strict();

export type CdlitAvailabilitySelectStaffRequest = z.infer<
  typeof cdlitAvailabilitySelectStaffRequestSchema
>;

export const cdlitAvailabilitySelectSlotRequestSchema = z
  .object({
    startAt: z.string().datetime(),
  })
  .strict();

export type CdlitAvailabilitySelectSlotRequest = z.infer<
  typeof cdlitAvailabilitySelectSlotRequestSchema
>;

export function assertNoForbiddenAvailabilityBodyFields(body: unknown): void {
  if (body == null || typeof body !== 'object' || Array.isArray(body)) {
    return;
  }
  for (const key of Object.keys(body as Record<string, unknown>)) {
    if ((CDLIT_AVAILABILITY_FORBIDDEN_BODY_FIELDS as readonly string[]).includes(key)) {
      throw new AiAdvanceValidationError(`Forbidden field: ${key}`);
    }
  }
}
